module.exports = __webpack_public_path__ + "img/5_101.23e00e25.png";